<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="700px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span v-if="item.id">Cập nhật dữ liệu</span>
        <span v-else>Thêm mới</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col
              v-if="!businessId"
              cols="12"
            >
              <v-select
                v-model="businessSelected"
                :items="businesses"
                item-text="ten_co_so"
                item-value="id"
                label="Cơ sở sản xuất"
                return-object
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.ten_npp"
                label="Tên gọi"
                autofocus
                class="require"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.dia_chi"
                label="Địa chỉ"
                class="require"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.vi_tri"
                label="Vị trí"
                class="require"    
                hide-details
              >
                <template slot="append-outer">
                  <v-btn fab small dark color="primary" @click="showMapDialog">
                    <v-icon>mdi-map-search-outline</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
              <Map 
                :showDialog="mapDialog" 
                :item="map" 
                @confirmed="onMapConfirmed" 
                @cancelled="onMapCancelled"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.so_giay_phep"
                label="Số giấy phép"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="item.don_vi_cap"
                label="Đơn vị cấp"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="item.ngay_cap"
                label="Ngày cấp"
                v-mask="'##/##/####'"
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import Map from '@/views/admin/businesses/Map';
  export default {
    components: { 
      Map
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      },
      businessId: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        mapDialog: false,
        map: {},
        businesses: [],
        businessSelected: null,
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          if(!this.businessId){
            this.getBusinesses();
          }
          this.businessSelected = this.businesses.find(
            element => element.id == this.item.doanhnghiep_id
          );
        }
      }
    },
    methods: {
      getBusinesses () {
        axios.get("api/v1/businesses")
          .then(response => {
            this.businesses = response.data.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      showMapDialog(){
        this.map = {
          address: this.item.dia_chi
        };
        this.mapDialog = true;
      },
      onMapConfirmed (item) {
        this.item.vi_tri = `${item.lat};${item.lng}`;
        this.mapDialog = false;
      },
      onMapCancelled () {
        this.mapDialog = false;
      },
      save(item) {
        const app = this;        
        let method = "post";
        let url = `api/v1/distributors`;
        let data = item;

        if(app.businessSelected){
          data.doanhnghiep_id = app.businessSelected.id;
        }

        if(app.businessId){
          data.doanhnghiep_id = app.businessId;
        }
        
        if (data.id) {
          method = "patch";
          url = `api/v1/distributors/${data.id}`;
        }

        app.loading=true;

        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
          }).catch(function (error) {
            app.loading=false;
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
    }
  }
</script>